import { defineComponent as _defineComponent } from 'vue'
import { nextTick, onMounted, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTablePseudoScrollBar',
  props: {
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isLoading: boolean;
};



const synchronizeScroll = () => {
  const tableWrapper = document.querySelector<HTMLElement>(
    '.v-data-table__wrapper'
  );
  const wrapper = document.querySelector<HTMLElement>('.pseudo-wrapper');
  const content = document.querySelector<HTMLElement>('.pseudo-content');

  if (!tableWrapper || !wrapper || !content) {
    return;
  }

  const tableElement = tableWrapper.querySelector('table');

  if (!tableElement) {
    return;
  }

  const dataTableContentWidth = tableElement.getBoundingClientRect().width;

  content.style.width = `${dataTableContentWidth}px`;
  tableWrapper.onscroll = () => {
    wrapper.scrollLeft = tableWrapper.scrollLeft;
  };
  wrapper.onscroll = function () {
    tableWrapper.scrollLeft = wrapper.scrollLeft;
  };

  const updateWidth = () => {
    const dataTableContentWidth = tableElement.scrollWidth;
    content.style.width = `${dataTableContentWidth}px`;
  };

  const resizeObserver = new ResizeObserver(() => {
    updateWidth();
  });
  resizeObserver.observe(tableElement);
  window.addEventListener('resize', updateWidth);
};

onMounted(() => {
  nextTick(() => {
    synchronizeScroll();
  });
});

watch(
  () => props.isLoading,
  () => {
    if (!props.isLoading) {
      synchronizeScroll();
    }
  }
);

return { __sfc: true,props, synchronizeScroll }
}

})